import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import Box from "@mui/material/Box";
import axios from "axios";



const Dialogs = ({
  pdfDialogOpen,
  setPdfDialogOpen,
  pdfUrl,
  rescheduleOpen,
  setRescheduleOpen,
  successDialogOpen,
  setSuccessDialogOpen,
  selectedEmployee,
  selectedEmployees,
  newDateTime,
  setNewDateTime,
  newEndDateTime,
  setNewEndDateTime,
  rescheduleType = "individual",
  setRescheduleType,
  refreshReports,
  examId,
  onRescheduleSuccess
}) => {
  const [rescheduleError, setRescheduleError] = React.useState("");
  const [fullScreen, setFullScreen] = React.useState(false);
  const getMinDateTime = () => {
    const now = new Date();
    now.setSeconds(0);
    now.setMilliseconds(0);

    const offset = now.getTimezoneOffset();
    const local = new Date(now.getTime() - offset * 60000);

    return local.toISOString().slice(0, 16);
  };
  const employeesForReschedule = selectedEmployees?.length
    ? selectedEmployees
    : selectedEmployee
      ? [selectedEmployee]
      : [];

  const isBatchReschedule = rescheduleType === "batch";

  const handleAddEmployee = async () => {
    try {
      const payload = {
        examData: [{ examId }],
        scheduleDate: newDateTime,
        workStart: new Date(newDateTime).toTimeString().split(" ")[0],
        workEnd: "23:59:59",
        assignedData: employeesForReschedule.map(employee => (
          {
            employee_guid: employee.employeeGuid,
            assignmentId: 1,
            employeeName: employee.name
          }
        ))
      };

      const response = await axios.post("/coordinators/manual_assignement/", payload, {
        headers: { "Content-Type": "application/json" },
        withCredentials: true
      });

      return response;

    } catch (err) {
      throw err;
    }
  };
  console.log("rescheduleType = pppppppppppppppppp", rescheduleType);

  const handleRescheduleConfirm = async () => {
    setRescheduleError("");

    try {
      if (!newDateTime) return;

      let response;

      // ✅ ADD FLOW
      if (rescheduleType === "add") {
        response = await handleAddEmployee();
      }

      // ✅ RESCHEDULE FLOW
      else {
        response = await handleRescheduleAPI();
      }

      const data = response.data;

      if (response.status >= 200 && response.status < 300) {
        if (rescheduleType === "add") {
          setRescheduleType("individual");
        }
        setRescheduleOpen(false);

        // Switch to Reschedule Assignments tab
        onRescheduleSuccess && onRescheduleSuccess();

        setSuccessDialogOpen(true);
        refreshReports && refreshReports();
      } else {
        setRescheduleError(data.error || "Operation failed");
      }

    } catch (err) {
      console.error(err);
      setRescheduleError("Something went wrong");
    }
  };

  const handleRescheduleAPI = async () => {
    try {
      // ✅ BATCH → Use the new reschedule procedure
      if (rescheduleType === "batch") {
        const payload = {
          exam_employee_ids: selectedEmployees.map(emp => emp.id),
          new_start_time: newDateTime,
          new_end_time: newEndDateTime
        };

        console.log("Batch reschedule payload:", payload);

        return await axios.post("/coordinators/reschedule-batch/", payload, {
          headers: { "Content-Type": "application/json" },
          withCredentials: true
        });
      }

      // ✅ INDIVIDUAL → Use the same reschedule procedure with single ID
      return await axios.post(
        "/coordinators/reschedule/",
        {
          exam_employee_ids: [selectedEmployee.id],
          new_start_time: newDateTime,
          new_end_time: newEndDateTime, // For individual, you might want to calculate end time
          modified_by: "system"
        },
        {
        headers: { "Content-Type": "application/json" },
        withCredentials: true
        }
      );

    } catch (err) {
      throw err;
    }
  };

  return (
    <>
      {/* <Dialog
        open={pdfDialogOpen}
        onClose={() => setPdfDialogOpen(false)}
        fullWidth
        maxWidth="md"
      > */}
      <Dialog
        open={pdfDialogOpen}
        onClose={() => setPdfDialogOpen(false)}
        fullWidth
        fullScreen={fullScreen}
        maxWidth={fullScreen ? false : "md"}
        PaperProps={{
          sx: {
            width: fullScreen ? "100%" : "80%",
            height: fullScreen ? "100%" : "85%",
            maxWidth: fullScreen ? "100%" : undefined,
            maxHeight: fullScreen ? "100%" : "90vh",
          }
        }}
      >
        {/* <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          Employee Report

          <IconButton onClick={() => setPdfDialogOpen(false)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle> */}
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          Employee Report

          <Box sx={{ display: "flex", alignItems: "center" }}>

            <IconButton onClick={() => setFullScreen(!fullScreen)}>
              {fullScreen ? (
                <FullscreenExitIcon />
              ) : (
                <FullscreenIcon />
              )}
            </IconButton>

            <IconButton onClick={() => setPdfDialogOpen(false)}>
              <CloseIcon />
            </IconButton>

          </Box>
        </DialogTitle>
        <DialogContent dividers>
          {pdfUrl ? (
            // <iframe
            //   src={pdfUrl}
            //   title="PDF Report"
            //   width="100%"
            //   height="600px"
            //   style={{
            //     border: "none"
            //   }}
            //   onContextMenu={(e) => e.preventDefault()}
            // />
            <iframe
              src={pdfUrl}
              title="PDF Report"
              width="100%"
              height={fullScreen ? "100%" : "650px"}
              style={{
                border: "none",
                minHeight: fullScreen ? "90vh" : "650px"
              }}
            />
          ) : (
            <Typography>No report available</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            className="btn-negative"
            onClick={() => setPdfDialogOpen(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={rescheduleOpen}
        onClose={() => setRescheduleOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{ borderRadius: '12px' }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #E7E8E9',
            padding: '10px 24px'
          }}
        >
          <Typography variant="h6">
            {rescheduleType === "add"
              ? "Add Employee"
              : isBatchReschedule
                ? "Confirm Batch Reschedule"
                : "Confirm Reschedule"}
          </Typography>

          <IconButton
            edge="end"
            color="inherit"
            onClick={() => {
              setRescheduleError("");
              setRescheduleOpen(false);
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent className="my-4 text-center">
          <img
            src="/images/queMark.png"
            alt="Warning"
            style={{
              width: 60,
              height: 60,
              marginBottom: 16
            }}
          />

          <DialogContentText>
            {rescheduleType === "add"
              ? `Are you sure you want to assign assessment to ${employeesForReschedule[0]?.name}?`
              : `Are you sure you want to reschedule the assessment for ${employeesForReschedule.length === 1
                ? employeesForReschedule[0].name
                : `${employeesForReschedule.length} employees`
              }?`
            }
          </DialogContentText>

          <TextField
            label={isBatchReschedule ? "Select Start Date & Time" : "Select Date & Time"}
            type="datetime-local"
            fullWidth
            value={newDateTime || ""}
            onChange={(e) => {
              setNewDateTime(e.target.value);
              setRescheduleError("");
            }}
            InputLabelProps={{ shrink: true }}
            inputProps={{
              min: getMinDateTime(),
            }}
            sx={{
              mt: 2,
              "& .MuiInputBase-root": {
                borderRadius: 2,
                backgroundColor: "white"
              }
            }}
          />

          {isBatchReschedule && (
            <TextField
              label="Select End Date & Time"
              type="datetime-local"
              fullWidth
              value={newEndDateTime || ""}
              onChange={(e) => {
                if (setNewEndDateTime) {
                  setNewEndDateTime(e.target.value);
                }
                setRescheduleError("");
              }}
              InputLabelProps={{ shrink: true }}
              inputProps={{
                min: newDateTime || getMinDateTime(),
              }}
              sx={{
                mt: 2,
                "& .MuiInputBase-root": {
                  borderRadius: 2,
                  backgroundColor: "white"
                }
              }}
            />
          )}

          {rescheduleError && (
            <Typography
              color="error"
              variant="body2"
              sx={{
                mt: 1,
                textAlign: "left"
              }}
            >
              {rescheduleError}
            </Typography>
          )}
        </DialogContent>

        <DialogActions
          sx={{
            padding: '1rem',
            borderTop: '1px solid #E7E8E9',
            justifyContent: 'center'
          }}
        >
          <button
            className="btn-negative"
            onClick={() => {
              setRescheduleError("");
              setRescheduleOpen(false);
            }}
          >
            Cancel
          </button>

          <button
            className="btn"
            onClick={handleRescheduleConfirm}
            disabled={!newDateTime || (isBatchReschedule && !newEndDateTime)}
          >
            Confirm
          </button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={successDialogOpen}
        onClose={() => setSuccessDialogOpen(false)}
        maxWidth="sm"
        fullWidth
        sx={{ borderRadius: '12px' }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid #E7E8E9',
            padding: '10px 24px'
          }}
        >
          <Typography variant="h6">
            <p>
              {rescheduleType === "add"
                ? "Assessment successfully assigned to"
                : "Assessment successfully rescheduled for"}
              <b>
                {employeesForReschedule.length === 1
                  ? employeesForReschedule[0].name
                  : `${employeesForReschedule.length} employees`}
              </b>{" "}
              {newDateTime
                ? new Date(newDateTime).toLocaleString()
                : ""}
            </p>
          </Typography>

          <IconButton
            edge="end"
            color="inherit"
            onClick={() => setSuccessDialogOpen(false)}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent>
          <div className="my-4 text-center">
            <img
              src="/images/succesfull-check.png"
              alt="Success"
              style={{
                width: 60,
                height: 60,
                marginBottom: 16
              }}
            />

            <p>
              Assessment successfully rescheduled for{" "}
              <b>
                {employeesForReschedule.length === 1
                  ? employeesForReschedule[0].name
                  : `${employeesForReschedule.length} employees`}
              </b>{" "}
              {newDateTime
                ? new Date(newDateTime).toLocaleString()
                : ""}
            </p>
          </div>
        </DialogContent>

        <DialogActions
          sx={{
            padding: '1rem',
            borderTop: '1px solid #E7E8E9',
            justifyContent: 'center'
          }}
        >
          <button
            className="btn"
            onClick={() => setSuccessDialogOpen(false)}
          >
            OK
          </button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Dialogs;
